export default __webpack_public_path__ + "imgs/public/avatar.jpg";